export default class SyncTasker {
  private timer: NodeJS.Timeout | null;
  private tasks: Function[];
  private delay: number;
  private inProgress: boolean;

  constructor(delay: number) {
    this.timer = null;
    this.tasks = [];
    this.delay = delay;
    this.inProgress = false;
  }

  public addTask = (f: Function) => {
    this.tasks.push(f);
    this.checker();
  };

  public abortTasks = () => {
    if (this.timer) {
      clearTimeout(this.timer);
      this.tasks = [];
    }
  };

  private checker = () => {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(this.taskRunner, this.delay);
  };

  private taskRunner = () => {
    if (this.tasks.length && !this.inProgress) {
      this.inProgress = true;
      this.tasks[this.tasks.length - 1]();
      this.inProgress = false;
      this.tasks = [];
    }
  };
}
